<template>
    <steps-option
        @updateNavigation="updateNavigation"
        :noColors="true"
    />
</template>

<style lang="scss"></style>

<script>
    import StepsOption from './StepsOption.vue';

    export default {
        components: {
            StepsOption,
        },

        mounted() {
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'pop_people_accessory',
                });
            }
        },

        methods: {
            updateNavigation(navRules) {
                // There should always be the next group because Pets step move.
                this.$emit('updateNavigation', navRules);
            },
        },
    };
</script>
